import React from 'react';

const useCases = [
{
  title: 'Daglig pendler i Oslo',
  steps: [
  { step: '01', text: 'Åpne NordPass og se sanntids trafikk på E18 og Ring 3' },
  { step: '02', text: 'Kalkuler bomkostnader for din daglige rute automatisk' },
  { step: '03', text: 'Motta varsler om veiarbeid og alternative ruter' },
  { step: '04', text: 'Se månedlig oversikt over kjørekostnader' }],

  img: "https://img.rocket.new/generatedImages/rocket_gen_img_16cc87b18-1772191891221.png",
  alt: 'Norwegian commuter driving on Oslo highway E18 during morning rush hour with city skyline visible'
},
{
  title: 'Langtransport over Dovrefjell',
  steps: [
  { step: '01', text: 'Planlegg rute med vær- og føreforhold for fjellovergangen' },
  { step: '02', text: 'Beregn totale bomkostnader for lastebil med tilhenger' },
  { step: '03', text: 'Last ned offline kart for områder uten mobildekning' },
  { step: '04', text: 'Eksporter kjørelogg til regnskapssystem' }],

  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1d3b6270e-1772191889928.png",
  alt: 'Heavy transport truck driving on Dovrefjell mountain pass in Norway with snow-covered peaks'
}];


const UseCases = () => {
  return (
    <section style={{ background: '#050A12', padding: '120px 0' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%' }}>
        {/* Header */}
        <div style={{ marginBottom: '80px' }}>
          <div style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '0.6875rem',
            color: '#3B6FD4',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
            BRUKSSCENARIER
          </div>
          <h2 style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: 'clamp(2rem, 4vw, 3.5rem)',
            fontWeight: 800,
            color: '#EEF0F2',
            letterSpacing: '-0.04em',
            lineHeight: 1,
            margin: 0
          }}>
            SLIK BRUKER
            <br /><span style={{ color: '#3B6FD4' }}>NORDMENN</span> NORDPASS
          </h2>
        </div>

        {/* Use cases */}
        {useCases?.map((uc, i) =>
        <div
          key={i}
          style={{
            display: 'grid',
            gridTemplateColumns: i % 2 === 0 ? '1fr 1fr' : '1fr 1fr',
            gap: '80px',
            alignItems: 'center',
            marginBottom: '100px',
            direction: i % 2 === 1 ? 'rtl' : 'ltr'
          }}>
          
            {/* Image */}
            <div style={{ direction: 'ltr', position: 'relative' }}>
              <img
              src={uc?.img}
              alt={uc?.alt}
              style={{
                width: '100%',
                height: '400px',
                objectFit: 'cover',
                filter: 'brightness(0.75) contrast(1.1)',
                display: 'block'
              }} />
            
              <div style={{
              position: 'absolute',
              bottom: '-2px',
              left: 0, right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, #3B6FD4, transparent)'
            }} />
            </div>

            {/* Steps */}
            <div style={{ direction: 'ltr' }}>
              <h3 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.03em',
              marginBottom: '36px'
            }}>{uc?.title}</h3>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                {uc?.steps?.map((s, j) =>
              <div
                key={j}
                style={{
                  display: 'flex',
                  gap: '20px',
                  padding: '20px 0',
                  borderBottom: j < uc?.steps?.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none'
                }}>
                
                    <div style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.75rem',
                  color: '#3B6FD4',
                  letterSpacing: '0.1em',
                  flexShrink: 0,
                  paddingTop: '2px'
                }}>{s?.step}</div>
                    <div style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.9375rem',
                  color: 'rgba(238,240,242,0.75)',
                  lineHeight: 1.6
                }}>{s?.text}</div>
                  </div>
              )}
              </div>

              <a
              href="/login"
              style={{
                display: 'inline-block',
                marginTop: '32px',
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: '#EEF0F2',
                textDecoration: 'none',
                padding: '12px 24px',
                background: '#3B6FD4',
                letterSpacing: '0.08em',
                textTransform: 'uppercase'
              }}>
              PRØV SELV →</a>
            </div>
          </div>
        )}
      </div>
    </section>);

};

export default UseCases;